type FabEventPageProps = {
    className?: string;
    size?: number;
    fill?: string;
};

const FabEventPage = ({className, size = 22, fill = 'currentColor'}: FabEventPageProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="28 28 24 24"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden
    >
        <path d="M34.1323 43.4221L32.1981 49.7927M29.5254 49.0755L34.8689 50.5066M31.3174 38.1714L34.8023 29.4935L41.3814 31.2528L39.4687 40.3536C39.3568 40.8974 39.1257 41.4133 38.7902 41.8688C38.4546 42.3243 38.0219 42.7093 37.5195 42.9993C37.0171 43.2893 36.456 43.4781 35.8718 43.5535C35.2876 43.629 34.6931 43.5897 34.126 43.4378C33.5589 43.286 33.0316 43.0251 32.5776 42.6717C32.1235 42.3182 31.7527 41.88 31.4886 41.3847C31.2245 40.8896 31.0729 40.3481 31.0434 39.795C31.0139 39.2418 31.1072 38.6889 31.3174 38.1714Z" />
        <path d="M33.0625 33.8188L40.4214 35.8065" />
        <path d="M42.8223 43.1651C43.5877 43.5197 44.4491 43.6499 45.2944 43.5387C46.1398 43.4275 46.9299 43.0801 47.5622 42.5415C48.1944 42.0029 48.6395 41.2981 48.8398 40.5187C49.0399 39.7394 48.9858 38.9215 48.6845 38.1714L45.1959 29.4935L44.1586 29.7693M45.8678 43.4221L47.802 49.7927M50.4747 49.0755L45.1311 50.5066M46.9375 33.8392L43.9317 34.6512" />
    </svg>
);

export default FabEventPage;
